import {
  GridRowModes,
  GridToolbarContainer,
  GridActionsCellItem,
  useGridApiRef,
  GridBooleanCell,
} from '@mui/x-data-grid-premium';
import { Box, Typography } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { dataGridPremiumColumns } from '../../utils/helper';
import { ButtonUI, DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import { useMemo, useState } from 'react';
import { EmployeeAttendanceSimpleMode } from '../../utils/employeeAttendance';
import dayjs from 'dayjs';
import { formatCurrency, getRounding } from '../../utils/currencyHelper';
import useParam from '../../context/ParamContext';
import { add } from 'mathjs';

const ProjectEmployeeAttendanceDetailsTable = ({ selectedValues }) => {
  const { params } = useParam();
  const apiRef = useGridApiRef();

  const rows = selectedValues.projectEmployeeAttendanceDetails ?? [];

  const contractorsManagementEnabled = params.EMPLOYEE_ATTENDANCE_CONTRACTORS_MANAGEMENT === 'Y';

  const pinnedRows = useMemo(
    () => ({
      bottom: [
        {
          id: 'total',
          timeSpent: rows.reduce((sum, row) => add(sum, Number(row.timeSpent) || 0), 0),
        },
      ],
    }),
    [selectedValues.projectEmployeeAttendanceDetails]
  );

  const columns = dataGridPremiumColumns([
    {
      field: 'employeeName',
      headerName: 'Dolgozó',
      type: 'string',
    },
    {
      field: 'attendanceDate',
      headerName: 'Dátum',
      type: 'date',
      valueGetter: (_data, row) => {
        return new Date(row.attendanceDate);
      },
      renderCell: (data) => (data.row.attendanceDate ? dayjs(data.row.attendanceDate).format('YYYY.MM.DD') : ''),
    },
    {
      field: 'fromTime',
      headerName: 'Kezdő időpont',
      type: 'time',
      valueGetter: (_data, row) => {
        return row.fromTime ? new Date(row.fromTime) : null;
      },
      renderCell: (data) => {
        return data.row.fromTime ? dayjs.utc(data.row.fromTime).format('HH:mm') : '';
      },
    },
    {
      field: 'toTime',
      headerName: 'Befejező időpont',
      type: 'time',
      valueGetter: (_data, row) => {
        return row.toTime ? new Date(row.toTime) : null;
      },
      renderCell: (data) => {
        return data.row.toTime ? dayjs.utc(data.row.toTime).format('HH:mm') : '';
      },
    },
    {
      field: 'timeSpent',
      headerName: 'Idő (óra)',
      type: 'number',
      aggregable: true,
      valueGetter: (params) => {
        const n = Number(params);
        return Number.isFinite(n) ? n : 0;
      },
    },
    ...(contractorsManagementEnabled
      ? [
          {
            field: 'companyName',
            headerName: 'Alvállalkozó',
            type: 'string',
          },
          {
            field: 'headCount',
            headerName: 'Létszám',
            type: 'number',
          },
        ]
      : []),
    {
      field: 'lineDescription',
      headerName: 'Tétel megjegyzés',
      type: 'string',
    },
  ]);

  return (
    <>
      <div className="overflow-x-auto">
        <div className="align-middle">
          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
            <DatagridPremiumUi
              apiRef={apiRef}
              datagridIdentifier={DataGridIdentifiers.ProjectEmployeeAttendanceDetailsTable}
              height={460}
              columns={columns}
              rows={selectedValues.projectEmployeeAttendanceDetails ?? []}
              headerFilters={false}
              slots={{
                toolbar: null,
              }}
              getRowHeight={() => 'auto'}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectEmployeeAttendanceDetailsTable;
